/**
 * Make Ticket manifest — `make-ticket` action.
 *
 * Walks any source → contact. Opens create-tickets modal pre-loaded with the
 * resolved contact as the ticket's primary contact + source entity reference.
 *
 * For deals: walks deal → company → contact (pick).
 */

import { MODAL_IDS } from "@west-tennessee-consulting/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "make-ticket",
  label: "Make ticket",
  primaryEntity: "contact",
  requires: {
    entity: "contact",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    hooks.openModal(MODAL_IDS.tickets.createQuick, {
      contactId: resolved.targetIds[0],
      sourceEntity: resolved.sourceEntity,
      sourceId: resolved.sourceId,
    });
  },
});
